import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

function useResponsiveImage({ desktop, mobile, fallback }) {
  const [src, setSrc] = useState(null)

  useEffect(() => {
    // TODO(Fase 3): unificar este breakpoint con los de @gojiraf/responsive
    // cuando se migren los layouts al nuevo criterio por ancho.
    const mediaQuery = window.matchMedia('(max-width: 768px)')
    let cancelled = false
    let img = null

    const loadImage = () => {
      const chosen = mediaQuery.matches ? mobile : desktop

      img = new Image()
      img.src = chosen
      img.onload = () => {
        if (!cancelled) setSrc(chosen)
      }
      img.onerror = () => {
        if (!cancelled) setSrc(fallback)
      }
    }

    loadImage()
    mediaQuery.addEventListener('change', loadImage)

    return () => {
      cancelled = true
      mediaQuery.removeEventListener('change', loadImage)
      if (img) {
        img.onload = null
        img.onerror = null
      }
    }
  }, [desktop, mobile, fallback])

  return src
}

/**
 * Un componente de imagen que muestra un fallback si la imagen original (src) falla.
 * @param {string} desktop - La fuente de la imagen para escritorio.
 * @param {string} mobile - La fuente de la imagen para móvil.
 * @param {string} fallback - La fuente de la imagen de fallback.
 * @param {object} rest - Cualquier otra prop de <img> (como className, style, width, height).
 */
export function BackgroundImageWithFallback({ desktop, mobile, fallback, children, ...rest }) {
  const bg = useResponsiveImage({
    desktop: desktop,
    mobile: mobile,
    fallback: fallback,
  })

  return (
    <div
      style={{
        backgroundImage: bg ? `url(${bg})` : 'none',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
      className="h-full w-full flex items-center justify-center absolute top-0 left-0 bg-cover bg-center"
      {...rest}
    >
      {children}
    </div>
  )
}

BackgroundImageWithFallback.propTypes = {
  desktop: PropTypes.string.isRequired,
  mobile: PropTypes.string.isRequired,
  fallback: PropTypes.string.isRequired,
  children: PropTypes.node,
}
